import React, { Fragment } from 'react';
import Splash from './pages/splash/Splash';
import Home from './pages/Home';
import Education from './pages/Education';
import Experience from './pages/Experience';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import './App.css';

function App() {
  return (
    <Router>
      <Fragment>
        <Switch>
          <Route exact path='/' component={Splash} />
          <Route exact path='/home' component={Home} />
          <Route exact path='/education' component={Education} />
          <Route exact path='/experience' component={Experience} />
          <Route exact path='/projects' component={Projects} />
          <Route exact path='/contact' component={Contact} />
        </Switch>
      </Fragment>
    </Router>
  );
}

export default App;
